import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	errorToggling: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorFetching: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorProvisioning: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	errorToggling: {
		id: 'project-directories.components.common.services.with-global-components-property.error-toggling',
		defaultMessage: 'Error updating Global Components Property',
		description:
			'Title for error flag shown when there is a problem updating global component status.',
	},
	errorFetching: {
		id: 'project-directories.components.common.services.with-global-components-property.error-fetching',
		defaultMessage: 'Error fetching Global Components Property',
		description:
			'Title for error flag shown when there is a problem fetching global component status.',
	},
	errorProvisioning: {
		id: 'project-directories.components.common.services.with-global-components-property.error-provisioning',
		defaultMessage: 'Error fetching Compass provisioning state',
		description: 'Title for error flag shown when there is a problem fetching provisioning status.',
	},
});
export default messages;
